import moment from "moment";
import React, { useEffect, useState } from "react";
import { CustomerContactsState } from "src/types";

import LineChart from "../generic/LineChart";
import * as helpers from "./helpers";

interface Props {
  customerContacts: CustomerContactsState;
}

const CustomersWithNbaChart: React.FC<Props> = ({
  customerContacts,
}: Props) => {
  const [chartData, setChartData] = useState<Array<{ x: string; y1: number }>>(
    []
  );
  const [xTicks, setXTicks] = useState<string[]>([]);
  useEffect(() => {
    const convertToPercent = (val: number, compare: number) =>
      compare > 0 ? parseFloat(((100 * val) / compare).toFixed(1)) : 0;

    setChartData(
      customerContacts.countPerInterval.map((intervalCounts) => ({
        x: intervalCounts.date,
        y1: convertToPercent(
          intervalCounts.countOfferAddressed,
          intervalCounts.countWithNba
        ),
        y2: convertToPercent(
          intervalCounts.countOfferAccepted,
          intervalCounts.countWithNba
        ),
        y3: convertToPercent(
          intervalCounts.countOfferDeclined,
          intervalCounts.countWithNba
        ),
        y4: convertToPercent(
          intervalCounts.countOfferObsolete,
          intervalCounts.countWithNba
        ),
      }))
    );
  }, [customerContacts]);

  useEffect(() => {
    if (chartData.length > 0) {
      setXTicks(helpers.getXDateTicks(chartData));
    }
  }, [chartData]);

  return (
    <LineChart
      chartId="diffCatChart"
      data={chartData}
      height={350}
      xTickLabelsAngled
      xlabel="Monat"
      xAxisLabelOffset={35}
      xTickFormatter={(xValue) =>
        helpers.xTickFunction(xTicks, xValue as string)
      }
      tooltipXValueFormatter={(xVal) =>
        helpers.getWeekRangeStringForDate(xVal as string)
      }
      axisAllocation={{
        left: ["y1", "y2", "y3", "y4"],
      }}
      yValueFormatterAxisLeft={(tick) => `${tick} %`}
      ylabelAxisLeft="Anteil"
      curveLabels={{
        y1: "Angebot angesprochen",
        y2: "Angebot angenommen",
        y3: "Angebot abgelehnt",
        y4: "Beratungsfokus nicht passend oder obsolet",
      }}
      averageLines={["y1"]}
      showCurveLegend
      lineColors={{
        y2: "#648c64",
        y3: "#be6e6e",
        y4: "#8b6a95",
      }}
    />
  );
};

export default CustomersWithNbaChart;



// WEBPACK FOOTER //
// ./src/components/NbaEvaluation/DifferentCategoriesChart.tsx